<div class="decline-page">
  <div class="decline-card">

    <div *ngIf="!isSuccess && !isError" class="state-box form-state">
      <div class="icon decline-icon">!</div>
      <h2>Decline Order</h2>
      <p class="message">
        Please provide the reason for declining this order.
      </p>

      <div class="form-group">
        <label for="declineReason">Decline Reason</label>
        <textarea id="declineReason"
                  class="reason-textarea"
                  [(ngModel)]="declineReason"
                  [disabled]="submitting"
                  (blur)="reasonTouched = true"
                  rows="6"
                  maxlength="500"
                  placeholder="Write the reason for declining the order..."></textarea>

        <div class="validation-error" *ngIf="isReasonInvalid">
          Decline reason is required.
        </div>

        <div class="char-count">
          It must be minimum <b>5</b> symbol.
          {{ declineReason?.length || 0 }}/500
        </div>
      </div>

      <div class="action-row">
        <button class="action-btn secondary-btn" type="button" (click)="goHome()" [disabled]="submitting">
          Cancel
        </button>

        <button class="action-btn danger-btn" type="button" (click)="declineOrder()" [disabled]="submitting || declineReason?.length<5">
          <span *ngIf="!submitting">Decline Order</span>
          <span *ngIf="submitting">Processing...</span>
        </button>
      </div>
    </div>

    <div *ngIf="isSuccess" class="state-box success-state">
      <div class="icon success-icon">✓</div>
      <h2>Order Declined</h2>
      <p class="message">{{ message }}</p>
      <p class="redirect-text">
        You will be redirected to the home page in
        <strong>{{ countdown }}</strong> seconds.
      </p>
      <button class="action-btn success-btn" (click)="goHome()">Go Home Now</button>
    </div>

    <div *ngIf="isError" class="state-box error-state">
      <div class="icon error-icon">✕</div>
      <h2>Decline Failed</h2>
      <p class="message">{{ message }}</p>
      <button class="action-btn error-btn" (click)="goHome()">Back to Home</button>
    </div>

  </div>
</div>
